import { Howl } from 'howler';
import bgMp3 from '../../assets/sound/bg.mp3';
import bgGameMp3 from '../../assets/sound/game_bg.mp3';
import gameMp3 from '../../assets/sound/game.mp3';
import btnMp3 from '../../assets/sound/button.mp3';
import fanfareMp3 from '../../assets/sound/fanfare.mp3';
import ship1Mp3 from '../../assets/sound/ship-1.mp3';
import ship2Mp3 from '../../assets/sound/ship-2.mp3';
import ship3Mp3 from '../../assets/sound/ship-3.mp3';
import finalBadMp3 from '../../assets/sound/final_bad.mp3';
import finalBestMp3 from '../../assets/sound/final_best.mp3';
import finalGoodMp3 from '../../assets/sound/final_good.mp3';
import CollisionMp3 from '../../assets/sound/ship_collision_ice.mp3';

const bg = new Howl({
  src: [bgMp3],
  loop: true,
});

const collision = new Howl({
  src: [CollisionMp3],
});

const bg_game = new Howl({
  src: [bgGameMp3],
  loop: true,
});

const game = new Howl({
  src: [gameMp3],
  loop: true,
});

const btn = new Howl({
  src: [btnMp3],
});

const fanfare = new Howl({
  src: [fanfareMp3],
});

const ship1 = new Howl({
  src: [ship1Mp3],
});

const ship2 = new Howl({
  src: [ship2Mp3],
});

const ship3 = new Howl({
  src: [ship3Mp3],
});

const final_bad = new Howl({
  src: [finalBadMp3],
});

const final_good = new Howl({
  src: [finalGoodMp3],
});

const final_best = new Howl({
  src: [finalBestMp3],
});

export const sounds = {
  bg,
  bg_game,
  game,
  fanfare,
  ship1,
  ship2,
  ship3,
  btn,
  final_bad,
  final_good,
  final_best,
  collision,
};
